// extracted by mini-css-extract-plugin
export default {"modalContent":"edit-user-modal_modalContent__rpt5B"};